import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import axios from "axios";
import { useEffect, useState } from "react";

const timeSlots = [
  "10:00 - 11:00",
  "11:00 - 12:00",
  "12:00 - 13:00",
  "15:00 - 16:00",
  "16:00 - 17:00",

];

const TimeSlotSelector = ({ selectedDate, selectedTime, setSelectedTime }) => {
  const [busySlots, setBusySlots] = useState([]);

  useEffect(() => {
    const fetchBusySlots = async () => {
      if (!selectedDate) return;
      try {
        const formattedDate = typeof selectedDate === "string"
          ? selectedDate.split("T")[0]
          : selectedDate.toISOString().split("T")[0];
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/calendar/availability`, {
          params: { date: formattedDate }
        });
        setBusySlots(response.data.busy || []);
      } catch (error) {
        console.error("Failed to fetch busy slots:", error);
      }
    };

    fetchBusySlots();
  }, [selectedDate]);

  const isSlotBusy = (slot) => {
    if (!selectedDate || busySlots.length === 0) return false;

    const [slotStart, slotEnd] = slot.split(" - ").map((t) => t.trim());
    const dateStr = typeof selectedDate === "string"
      ? selectedDate.split("T")[0]
      : selectedDate.toISOString().split("T")[0];
    const slotStartISO = new Date(`${dateStr}T${slotStart}:00`).toISOString();
    const slotEndISO = new Date(`${dateStr}T${slotEnd}:00`).toISOString();

    return busySlots.some((busy) => {
      const busyStart = new Date(busy.start).toISOString();
      const busyEnd = new Date(busy.end).toISOString();

      const overlap =
        (slotStartISO >= busyStart && slotStartISO < busyEnd) ||
        (slotEndISO > busyStart && slotEndISO <= busyEnd) ||
        (slotStartISO <= busyStart && slotEndISO >= busyEnd);

      if (overlap) {
        console.log("⛔ Detected overlap for slot:", slot);
        console.log("  🟨 Slot ISO:", slotStartISO, "-", slotEndISO);
        console.log("  🟥 Busy ISO:", busyStart, "-", busyEnd);
      }

      return overlap;
    });
  };

  // Removed date check to allow step 2 to show independently

  return (
    <section className="mt-6 flex flex-col" aria-label="Step 2: Seleziona un orario">
      <h3 className="text-md font-semibold mb-2 flex justify-between items-center">
        <span className="flex-1 text-left">Seleziona un orario</span>
        <span className="text-sm text-gray-500 pr-4 flex items-center gap-1">
          <AccessTimeIcon style={{ fontSize: "16px", color: "#6b7280" }} />
          1 ora
        </span>
      </h3>
      <div className="grid grid-cols-1 gap-2 overflow-y-auto max-h-72 pr-2">
        {timeSlots.map((slot) => {
          if (isSlotBusy(slot)) {
            return (
              <button
                key={slot}
                disabled
                className="p-2 rounded-md border bg-gray-200 text-gray-400 cursor-not-allowed"
              >
                {slot}
              </button>
            );
          }

          return (
            <button
              key={slot}
              onClick={() => {
                console.log("✅ Time selected:", slot);
                const [start, end] = slot.split(" - ");
                const dateStr =
                  typeof selectedDate === "string"
                    ? selectedDate.split("T")[0]
                    : selectedDate.toISOString().split("T")[0];
                const startDateTime = new Date(`${dateStr}T${start}:00`);
                const endDateTime = new Date(`${dateStr}T${end}:00`);
                
                // Check 24-hour minimum booking restriction
                const now = new Date();
                const timeDifference = startDateTime.getTime() - now.getTime();
                const hoursDifference = timeDifference / (1000 * 60 * 60);

                if (hoursDifference < 24) {
                  alert("La prenotazione deve essere effettuata con almeno 24 ore di anticipo rispetto all'orario selezionato.");
                  return; // Don't select the time
                }

                console.log("📆 ISO Start:", startDateTime.toISOString());
                console.log("📆 ISO End:", endDateTime.toISOString());
                setSelectedTime({
                  raw: slot,
                  start: startDateTime.toISOString(),
                  end: endDateTime.toISOString(),
                });
              }}
              className={`p-2 rounded-md border ${
                selectedTime?.raw === slot
                  ? "bg-[#304563] text-white"
                  : "bg-white text-gray-800"
              }`}
            >
              {slot}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default TimeSlotSelector;